// Import animation, motion
import { motion } from 'framer-motion';
import { childQuiz } from '../../utils/animations';

// Import icons, images
import logoWhite from '../../assets/images/citroen-logo.png';

const Survey = ({ handleSurveyClick, filterCurrentSurvey, data }) => {
  return (
    <>
      {' '}
      <div className="survey-label">
        <img src={logoWhite} alt="citroen-logo" />

        <p>
          {' '}
          {filterCurrentSurvey.id === 0 ? (
            <p>Hej! Preden začnemo, se na hitro spoznajmo 👋🏼</p>
          ) : filterCurrentSurvey.id === 1 ? (
            <p>{data.surveyLabel}</p>
          ) : filterCurrentSurvey.id === 2 ? (
            <p>Zanima nas samo še to ...</p>
          ) : null}
        </p>
      </div>
      <motion.div variants={childQuiz}>
        <p
          className="question-text px-2"
          dangerouslySetInnerHTML={{ __html: filterCurrentSurvey.surveyText }}
        ></p>
        <div className="row g-0 answer-section text-center">
          {filterCurrentSurvey.answerOptions.map((answerOption, index) => (
            <div key={index} className="col-12">
              <button
                id={`answer-${index}`}
                className="btn btn-survey"
                onClick={() => {
                  handleSurveyClick(
                    answerOption.path,
                    answerOption.answerTags,
                    answerOption.answerText,
                    index
                  );
                }}
              >
                <span>{answerOption.answerText}</span>
              </button>
            </div>
          ))}
        </div>
      </motion.div>
    </>
  );
};

export default Survey;
